import { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './ActorProfileFeedback.module.less';
import Translations from '../../../utils/Translations';

const ActorProfileFeedbackListItem = ({ item, isAnswer, actor }) => {
	const { answer, comment, date, userName, userPictureUrl } = item;

	const [needShowMore, setNeedShowMore] = useState(false);
	const [showMore, setShowMore] = useState(false);

	const setCommentRef = (ref) => {
		if (ref && ref.getBoundingClientRect().width + 50 > ref.parentElement.clientWidth) {
			setNeedShowMore(true);
		}
	};

	return (
		<li
			className={cx(style['feedback__list-item'], {
				[style['feedback__list-item--has-answer']]: answer,
				[style['feedback__list-item--is-answer']]: isAnswer,
			})}
		>
			<img className={style['feedback__list-item__image']} src={userPictureUrl} alt={`Bild von ${userName}`} />
			<div className={style['feedback__list-item__name']}>{userName}</div>
			<div className={style['feedback__list-item__feedback-wrapper']}>
				<span
					className={cx(style['feedback__list-item__feedback'], {
						[style['feedback__list-item__feedback--show-all']]: showMore,
					})}
					ref={(ref) => setCommentRef(ref)}
				>
					{comment}
				</span>
				{needShowMore && !showMore && (
					<span className={style['feedback__list-item__feedback-more']} onClick={() => setShowMore(true)}>
						{Translations.get('common.more')}
					</span>
				)}
			</div>
			{!isAnswer && <div className={style['feedback__list-item__date']}>{date}</div>}
			{answer && !isAnswer && (
				<ActorProfileFeedbackListItem
					item={{ userPictureUrl: actor.picture, userName: actor.name, comment: answer }}
					isAnswer={true}
					actor={actor}
				/>
			)}
		</li>
	);
};

ActorProfileFeedbackListItem.propTypes = {
	item: PropTypes.object,
	actor: PropTypes.object,
	isAnswer: PropTypes.bool,
};

ActorProfileFeedbackListItem.defaultProps = {
	isAnswer: false,
};

export default ActorProfileFeedbackListItem;
